import React from "react";
import CrudResource from "./CrudResource";

const fields = [
  { key: "customer_name", label: "Müşteri Adı" },
  { key: "company", label: "Firma" },
  { key: "avatar_url", label: "Fotoğraf / Logo", type: "media", accept: "image", span: 2 },
  { key: "quote_tr", label: "Yorum (TR)", type: "textarea", span: 2 },
  { key: "quote_en", label: "Yorum (EN)", type: "textarea", span: 2 },
  { key: "rating", label: "Puan (1-5)", type: "number" },
  { key: "service_slug", label: "Hizmet Slug" },
  { key: "order", label: "Sıra", type: "number" },
  { key: "active", label: "Aktif", type: "checkbox" },
];
const defaults = { customer_name: "", company: "", rating: 5, order: 100, active: true };

export default function AdminTestimonials() {
  return <CrudResource resource="testimonials" publicPath="testimonials" title="Müşteri Yorumları" fields={fields} defaults={defaults} />;
}
